/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
const INITIAL_CONTEXT = {
  idle: {},
  GET_LABEL_PDF: {},
};

const MACHINE_CONFIG = {
  id: "io.vlinder.gems.printLabel.getLabelPDF",
  initial: "idle",
  context: INITIAL_CONTEXT,
  states: {
    idle: {
      entry: ["resetAction"],
      on: {
        MUTATE: { target: "GET_LABEL_PDF" },
      },
    },
    GET_LABEL_PDF: {
      invoke: {
        id: "getLabelPDF",
        src: "getLabelPDF",
        onDone: {
          target: "GET_LABEL_PDF_SUCCESS",
          actions: ["successAction"],
        },
        onError: {
          target: "GET_LABEL_PDF_FAILED",
          actions: ["failureAction"],
        },
      },
    },
    GET_LABEL_PDF_SUCCESS: {
      on: {
        MUTATE: { target: "GET_LABEL_PDF" },
      },
    },
    GET_LABEL_PDF_FAILED: {
      on: {
        MUTATE: { target: "GET_LABEL_PDF" },
      },
    },
  },
};

//Machine(MACHINE_CONFIG)

export { INITIAL_CONTEXT, MACHINE_CONFIG };
